import { APP_NAME, getAppInfo } from 'util/appInfo';

const DEFAULT_JOIN_WITH_AUDIO_BUTTON_STATE = {
    [APP_NAME.F]: false,
    [APP_NAME.K]: false,
    [APP_NAME.T]: false,
    [APP_NAME.S]: false,
};

const DEFAULT_JOIN_WITH_VIDEO_BUTTON_STATE = {
    [APP_NAME.F]: false,
    [APP_NAME.K]: false,
    [APP_NAME.T]: false,
    [APP_NAME.S]: false,
};

const { currentAppName } = getAppInfo();

export const CURRENT_JOIN_WITH_AUDIO_BUTTON_STATE = DEFAULT_JOIN_WITH_AUDIO_BUTTON_STATE[currentAppName];
export const CURRENT_JOIN_WITH_VIDEO_BUTTON_STATE = DEFAULT_JOIN_WITH_VIDEO_BUTTON_STATE[currentAppName];

export const LAST_USED_MIC_KEY = 'LAST_USED_MIC_KEY';
export const LAST_USED_SPEAKER_KEY = 'LAST_USED_SPEAKER_KEY';
export const LAST_USED_SPEAKER_VOLUME = 'LAST_USED_SPEAKER_VOLUME';
export const DEFAULT_SPEAKER_VOLUME = 1; // 100%
